import { render, staticRenderFns } from "./AlarmPointsTable.vue?vue&type=template&id=39fc4d34&scoped=true"
import script from "./AlarmPointsTable.vue?vue&type=script&lang=ts"
export * from "./AlarmPointsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc4d34",
  null
  
)

export default component.exports